import { render, staticRenderFns } from "./AtomEmptyPlaceholder.vue?vue&type=template&id=2a0e31ee&"
import script from "./AtomEmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./AtomEmptyPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./AtomEmptyPlaceholder.vue?vue&type=style&index=0&id=2a0e31ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/AtomEmptyPlaceholder.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fatoms%2Fcommon%2FAtomEmptyPlaceholder.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports